
import { formatDate, gettersInstance, propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Parcel } from "@/lib/types/Parcel";
import { RawLocation } from "vue-router";

interface ParcelMenuItemProps {
  parcel: Parcel;
}

const Props = propsInstance<ParcelMenuItemProps>({
  parcel: {
    type: Object,
    required: true,
  },
});

const StoreGetters = gettersInstance(["currentFarmId", "currentSeasonId", "selectedParcel", "selectedParcelId", "selectedDate", "latestDate"]);

@Component({
  name: "ParcelMenuItem",
})
export default class ParcelMenuItem extends mixins(MixedVue, Props, StoreGetters) {
  get evolutionRoute(): RawLocation {
    return {
      name: "parcel-history",
      params: {
        parcelId: this.selectedParcelId,
        seasonId: this.currentSeasonId,
        farmId: this.currentFarmId,
      },
      query: {
        rasterKind: this.rasterKind,
        backTo: this.$route.fullPath,
      },
    };
  }

  get routeToMap(): RawLocation {
    const date = this.latestDate || this.selectedDate || new Date();
    if (!this.currentFarmId || !date || !this.selectedParcelId || !this.currentSeasonId) return "";
    return {
      name: "map-observation-details",
      params: {
        farmId: this.currentFarmId,
        date: formatDate(date),
        parcelId: this.selectedParcelId,
        seasonId: this.currentSeasonId,
      },
      query: {
        rasterKind: this.rasterKind,
      },
    };
  }
}
